export default __webpack_public_path__ + "img/thanks.f0e7e7cc.png";